import { render, staticRenderFns } from "./recevice-sure.vue?vue&type=template&id=f6980e1c&scoped=true&lang=pug&"
import script from "./recevice-sure.vue?vue&type=script&lang=js&"
export * from "./recevice-sure.vue?vue&type=script&lang=js&"
import style0 from "./recevice-sure.vue?vue&type=style&index=0&id=f6980e1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6980e1c",
  null
  
)

export default component.exports